"use client";

import React, {useEffect, useState, useCallback, useRef} from "react";

interface Section {
    id: string;
    title: string;
}

const sections: Section[] = [
    {id: "product-information-md", title: "اطلاعات کالا"},
    {id: "comment-header-section", title: "دیدگاه کاربران"},
];

export default function ScrollNavigationComment() {
    const [isVisible, setIsVisible] = useState(false);
    const [activeSection, setActiveSection] = useState("");
    const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const isProgrammaticScroll = useRef(false);

    const handleScroll = useCallback(() => {
        if (isProgrammaticScroll.current) {
            isProgrammaticScroll.current = false;
            return;
        }
        const scrollPosition = window.scrollY + 100; // Offset for fixed header
        let currentSection = "";
        for (const section of sections) {
            const element = document.getElementById(section.id);
            if (element) {
                const elementTop = element.offsetTop;
                const elementBottom = elementTop + element.offsetHeight;
                if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
                    currentSection = section.id;
                    break;
                }
            }
        }
        setActiveSection(currentSection);
        const commentHeaderSection = document.getElementById("comment-header-section");
        if (commentHeaderSection) {
            setIsVisible(scrollPosition >= commentHeaderSection.offsetTop - 100);
        }
    }, []);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            isProgrammaticScroll.current = true;
            setActiveSection(sectionId);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
            const offset = 100;
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            scrollTimeoutRef.current = setTimeout(() => {
                isProgrammaticScroll.current = false;
            }, 1000);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Check initial state
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, [handleScroll]);

    if (!isVisible) {
        return null;
    }

    return (
        <div
            className="w-full lg:flex hidden h-[55px] px-[23px] fixed top-12 left-0 text-sm bg-white shadow-sm border-t border-gray-100 z-50 items-center justify-between">
            {sections.map((section) => (
                <button
                    key={section.id}
                    className={`pb-2 cursor-pointer ${
                        activeSection === section.id
                            ? "border-orange-primary border-b-2 text-orange-primary"
                            : "text-gray-600 hover:text-orange-primary"
                    }`}
                    onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(section.id);
                    }}
                >
                    {section.title}
                </button>
            ))}
        </div>
    );
}